<template>
  <DashboardTrabajos />
</template>

<script>
export default {
  components: {
    DashboardTrabajos: () => import('@/components/user/CuerpoTrabajo.vue')
  },
  data: () => {
    return {};
  },

  mounted() {
  }
};
</script>
